import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $numberUtils from '@/models/numberUtils.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const ifilAbsContract = require('./CommitteeElect.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.CommitteeElectProxyAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(ifilAbsContract.abi, contractAddress) : '',
}

const getCommitteeElectProxyAddress = () => {
    return contractAddress;
}

const getCommitteeElectProxyContract = () => {
    return contractConst.contract;
}

const getcfg = () =>{
    return $web3js.call(getCommitteeElectProxyContract().methods.cfg);
}

const getLastCandidateInfoByAddress = ([address]) =>{
    return $web3js.call(getCommitteeElectProxyContract().methods.getLastCandidateInfoByAddress,[address],{},handlLastCandidateInfos);
}

const handlLastCandidateInfos = async(res2) => {
            let index = 0;
            let cid = res2[index++];
            let candidate = res2[index++];
            let depositMvtAmount = res2[index++];
            let withdrawMvtAmount = res2[index++];
            let voteCount = res2[index++];
            let unvoteCount = res2[index++];
            let quitBlock = res2[index++];
            let gainedBlock = res2[index++];
            let unlockedBenefit = res2[index++];
            let withdrawBenefit = res2[index++];
            let state = res2[index++];

            let mvtAddress = $erc20.getErc20Address('MVT');
            let dmcAddress = $erc20.getErc20Address('DMC');
            //depositMvtAmount = await $erc20.fromErc20Value(depositMvtAmount, mvtAddress);
            let electMvtAmount = $numberUtils.sub(depositMvtAmount,withdrawMvtAmount);
            electMvtAmount = await $erc20.fromErc20Value(electMvtAmount, mvtAddress);
            let myVoteCount = $numberUtils.sub(voteCount,unvoteCount);
            myVoteCount = await $erc20.fromErc20Value(myVoteCount, mvtAddress);
            let myCandidateCount =  $numberUtils.sub(myVoteCount,electMvtAmount);
            //myCandidateCount = await $erc20.fromErc20Value(myCandidateCount, mvtAddress);
            voteCount = await $erc20.fromErc20Value(voteCount, mvtAddress);
            let myBenefitDMC = $numberUtils.sub(unlockedBenefit,withdrawBenefit);
            myBenefitDMC = await $erc20.fromErc20Value(myBenefitDMC, dmcAddress);

           
            return {
                cid,
                candidate,
                depositMvtAmount,
                withdrawMvtAmount,
                voteCount,
                unvoteCount,
                myVoteCount,
                myCandidateCount,
                quitBlock,
                gainedBlock,
                unlockedBenefit,
                withdrawBenefit,
                myBenefitDMC,
                electMvtAmount,
                state
            };
    
};


const getCandidateInfos = () => {
    return $web3js.call(getCommitteeElectProxyContract().methods.getCandidateInfos,[],{},handlCandidateInfos);
};

const handlCandidateInfos = async(res2) => {
    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let cid = res[index++];
            let candidate = res[index++];
            let depositMvtAmount = res[index++];
            let withdrawMvtAmount = res[index++];
            let voteCount = res[index++];
            let unvoteCount = res[index++];
            let quitBlock = res[index++];
            let gainedBlock = res[index++];
            let unlockedBenefit = res[index++];
            let withdrawBenefit = res[index++];
            let state = res[index++];

            let mvtAddress = $erc20.getErc20Address('MVT');
            //depositMvtAmount = await $erc20.fromErc20Value(depositMvtAmount, mvtAddress);
            let electMvtAmount = $numberUtils.sub(depositMvtAmount,withdrawMvtAmount);
            electMvtAmount = await $erc20.fromErc20Value(electMvtAmount, mvtAddress);
            let myVoteCount = $numberUtils.sub(voteCount,unvoteCount);
            myVoteCount = await $erc20.fromErc20Value(myVoteCount, mvtAddress);

            let item = {
                cid,
                candidate,
                depositMvtAmount,
                withdrawMvtAmount,
                voteCount,
                unvoteCount,
                myVoteCount,
                quitBlock,
                gainedBlock,
                unlockedBenefit,
                withdrawBenefit,
                electMvtAmount,
                state
            }
            resList.push(item);
        }
    }
    return resList;
};


const getVoteInfos = ([user,cids]) => {
    return $web3js.call(getCommitteeElectProxyContract().methods.getVoteInfos,[user,cids],{},handlVoteInfos);
};

const handlVoteInfos = async(res2) => {
    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let cid = res[index++];
            let apy = res[index++];
            let gainedBlock = res[index++];
            let voteCount = res[index++];
            let unvoteCount = res[index++];
            let unlockedBenefit = res[index++];
            let withdrawBenefit = res[index++];

            let mvtAddress = $erc20.getErc20Address('MVT');
            let dmcAddress = $erc20.getErc20Address('DMC');
            //depositMvtAmount = await $erc20.fromErc20Value(depositMvtAmount, mvtAddress);
            let myVoteCount = $numberUtils.sub(voteCount,unvoteCount);
            myVoteCount = await $erc20.fromErc20Value(myVoteCount, mvtAddress);
            let myBenefitDMC = $numberUtils.sub(unlockedBenefit,withdrawBenefit);
            myBenefitDMC = await $erc20.fromErc20Value(myBenefitDMC, dmcAddress);

            let item = {
                cid,
                apy,
                gainedBlock,
                voteCount,
                unvoteCount,
                myVoteCount,
                unlockedBenefit,
                withdrawBenefit,
                myBenefitDMC
            }
            resList.push(item);
        }
    }
    return resList;
};

const getUserVoteInfos = ([user]) => {
    return $web3js.call(getCommitteeElectProxyContract().methods.userInfoMap,[user],{},handlUserVoteInfos);
};

const handlUserVoteInfos = async(res2) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    let myVoteCount = $numberUtils.sub(res2.voteCount,res2.unvoteCount);
    myVoteCount = await $erc20.fromErc20Value(myVoteCount, mvtAddress);
    return myVoteCount;
};

//dmc
const getUserIncomes = ([user]) => {
    return $web3js.call(getCommitteeElectProxyContract().methods.getUserIncome,[user],{},handlUserIncome);
};

const handlUserIncome = async(res2) => {
    
    
    // let resList = [];
    // if (res2.length > 0) {
    //     for (let res of res2) {
    //         let index = 0;
    //         let remainVote = res[index++];
    //         let availBenefit = res[index++];
    //         let unlockedBenefit = res[index++];
            

    //         let item = {
    //             remainVote,
    //             availBenefit,
    //             unlockedBenefit
    //         }
    //         resList.push(item);
    //     }
    // }
    // return resList;
    if(res2){
        let dmcAddress = $erc20.getErc20Address('DMC');
        let availBenefit = await $erc20.fromErc20Value(res2.availBenefit, dmcAddress);;
        let item = {
            remainVote:res2.remainVote,
            availBenefit:availBenefit,
            unlockedBenefit:res2.unlockedBenefit,
        }
        return item;
    }
    return '';

};


const sendElect = ([user,cid], options, callback) => {
    return $web3js.send(getCommitteeElectProxyContract().methods.elect,['',''],options, callback);
};

const sendElectEstimateSend = async([user,cid], options) => {

    //_amount = await $erc20.toErc20Value(_amount, _contractAddress);


    let gasPromise = $web3js.estimateSend(getCommitteeElectProxyContract().methods.elect, ['',''], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const quitElect = ([cid], options, callback) => {
    return $web3js.send(getCommitteeElectProxyContract().methods.quit,[cid],options, callback);
};
const quitElectEstimateSend = async([cid], options) => {
    let gasPromise = $web3js.estimateSend(getCommitteeElectProxyContract().methods.quit, [cid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


const sendElectVote = async ([cid,ticket], options, callback) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    ticket = await $erc20.toErc20Value(ticket, mvtAddress);
    return $web3js.send(getCommitteeElectProxyContract().methods.vote,[cid,ticket],options, callback);
};
const electVoteEstimateSend = async([cid,ticket], options) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    ticket = await $erc20.toErc20Value(ticket, mvtAddress);
    let gasPromise = $web3js.estimateSend(getCommitteeElectProxyContract().methods.vote, [cid,ticket], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const sendElectUnVote = async ([cid,ticket], options, callback) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    ticket = await $erc20.toErc20Value(ticket, mvtAddress);
    return $web3js.send(getCommitteeElectProxyContract().methods.unvote,[cid,ticket],options, callback);
};
const electUnVoteEstimateSend = async([cid,ticket], options) => {
    let mvtAddress = $erc20.getErc20Address('MVT');
    ticket = await $erc20.toErc20Value(ticket, mvtAddress);
    let gasPromise = $web3js.estimateSend(getCommitteeElectProxyContract().methods.unvote, [cid,ticket], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


const sendElectIncome = ([cid], options, callback) => {
    return $web3js.send(getCommitteeElectProxyContract().methods.income,[],options, callback);
};
const electIncomeEstimateSend = async([cid], options) => {
    let gasPromise = $web3js.estimateSend(getCommitteeElectProxyContract().methods.income, [], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


export default {
    getCommitteeElectProxyAddress,
    getCommitteeElectProxyContract,
    getcfg,
    getLastCandidateInfoByAddress,
    getCandidateInfos,
    getVoteInfos,
    getUserVoteInfos,
    sendElect,
    sendElectEstimateSend,
    quitElect,
    quitElectEstimateSend,
    sendElectVote,
    electVoteEstimateSend,
    sendElectUnVote,
    electUnVoteEstimateSend,

    sendElectIncome,
    electIncomeEstimateSend,
    getUserIncomes
}




// WEBPACK FOOTER //
// ./src/lib/contract/CommitteeElect/index.js